var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchUtils } from 'ra-core';
import postgrestRestProvider, { defaultPrimaryKeys, defaultSchema, } from '@raphiniert/ra-data-postgrest';
/**
 * A function that returns a dataProvider for Supabase.
 * @param instanceUrl The URL of the Supabase instance
 * @param apiKey The API key of the Supabase instance. Prefer the anonymous key.
 * @param supabaseClient The Supabase client
 * @param defaultListOp Optional - The default list filter operator. Defaults to 'eq'.
 * @param primaryKeys Optional - The primary keys of the tables. Defaults to 'id'.
 * @param schema Optional - The custom schema to use. Defaults to none.
 * @returns A dataProvider for Supabase
 */
export var supabaseDataProvider = function (_a) {
    var instanceUrl = _a.instanceUrl, apiKey = _a.apiKey, supabaseClient = _a.supabaseClient, _b = _a.httpClient, httpClient = _b === void 0 ? supabaseHttpClient({ apiKey: apiKey, supabaseClient: supabaseClient }) : _b, _c = _a.defaultListOp, defaultListOp = _c === void 0 ? 'eq' : _c, _d = _a.primaryKeys, primaryKeys = _d === void 0 ? defaultPrimaryKeys : _d, _e = _a.schema, schema = _e === void 0 ? defaultSchema : _e;
    var config = {
        apiUrl: "".concat(instanceUrl, "/rest/v1"),
        httpClient: httpClient,
        defaultListOp: defaultListOp,
        primaryKeys: primaryKeys,
        schema: schema,
    };
    return postgrestRestProvider(config);
};
/**
 * A function that returns a httpClient for Supabase. It handles the authentication.
 * @param apiKey The API key of the Supabase instance. Prefer the anonymous key.
 * @param supabaseClient The Supabase client
 * @returns A httpClient for Supabase
 */
export var supabaseHttpClient = function (_a) {
    var apiKey = _a.apiKey, supabaseClient = _a.supabaseClient;
    return function (url, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, supabaseClient.auth.getSession()];
                    case 1:
                        data = (_a.sent()).data;
                        if (!options.headers)
                            options.headers = new Headers({});
                        if (supabaseClient['headers']) {
                            Object.entries(supabaseClient['headers']).forEach(function (_a) {
                                var name = _a[0], value = _a[1];
                                return options.headers.set(name, value);
                            });
                        }
                        if (data.session) {
                            options.user = {
                                authenticated: true,
                                // This ensures that users are identified correctly and that RLS can be applied
                                token: "Bearer ".concat(data.session.access_token),
                            };
                        }
                        // Always send the apiKey even if there isn't a session
                        options.headers.set('apiKey', apiKey);
                        return [2 /*return*/, fetchUtils.fetchJson(url, options)];
                }
            });
        });
    };
};
